<div class="container mx-auto p-4 bg-[#F5F7FA] min-h-screen">
  <!-- En-tête -->
  <div class="mb-6">
    <h1 class="text-3xl font-bold text-[#1E293B] mb-2">{{ t('reclamations.pageTitle') }}</h1>
    <p class="text-gray-600">{{ t('reclamations.subtitle') }}</p>
  </div>

  <!-- Barre de recherche et actions -->
  <div class="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 mb-6">
    <!-- Recherche -->
    <div class="relative w-full lg:w-96">
      <input type="text" [(ngModel)]="searchTerm" (input)="searchReclamations()"
        [placeholder]="t('reclamations.searchPlaceholder')"
        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF5C01] focus:border-transparent" />
      <svg xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>

    <!-- Boutons d'action -->
    <div class="flex gap-3 w-full lg:w-auto">
      <button
        class="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-gray-600" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
        </svg>
        <span class="text-gray-700 font-medium">{{ t('reclamations.filters') }}</span>
      </button>

      <button
        class="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2 text-gray-600" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
        </svg>
        <span class="text-gray-700 font-medium">{{ t('reclamations.export') }}</span>
      </button>
    </div>
  </div>

  <!-- Tableau des réclamations -->
  <div class="bg-white rounded-lg shadow-sm overflow-hidden">
    <div class="overflow-x-auto">
      <table class="w-full">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('reclamations.table.user') }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('reclamations.table.subject') }}
            </th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('reclamations.table.category') }}
            </th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('reclamations.table.status') }}
            </th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('reclamations.table.date') }}</th>
            <th class="px-6 py-4 text-left text-sm font-semibold text-gray-700">{{ t('reclamations.table.actions') }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <tr *ngFor="let reclamation of filteredReclamations" class="hover:bg-gray-50 transition-colors">
            <!-- Utilisateur avec avatar et point de statut -->
            <td class="px-6 py-4">
              <div class="flex items-center">
                <div class="relative mr-3">
                  <div
                    class="w-10 h-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white text-lg">
                    {{ reclamation.utilisateur.avatar }}
                  </div>
                  <div class="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white"
                    [ngClass]="getPointColor(reclamation.utilisateur.pointStatut)"></div>
                </div>
                <div>
                  <div class="text-sm font-semibold text-gray-900">{{ reclamation.utilisateur.nom }}</div>
                  <div class="text-sm text-gray-500">{{ reclamation.utilisateur.email }}</div>
                </div>
              </div>
            </td>

            <!-- Sujet -->
            <td class="px-6 py-4">
              <span class="text-sm text-gray-700">{{ reclamation.sujet }}</span>
            </td>

            <!-- Catégorie -->
            <td class="px-6 py-4">
              <span class="text-sm text-gray-700">{{ reclamation.categorie }}</span>
            </td>

            <!-- Statut -->
            <td class="px-6 py-4">
              <span class="px-3 py-1 rounded-full text-xs font-medium" [ngClass]="getStatutClass(reclamation.statut)">
                {{ mapStatusToTranslation(reclamation.statut) }}
              </span>
            </td>

            <!-- Date -->
            <td class="px-6 py-4">
              <span class="text-sm text-gray-700">{{ reclamation.date }}</span>
            </td>

            <!-- Actions -->
            <td class="px-6 py-4">
              <button (click)="viewReclamation(reclamation)" class="text-gray-600 hover:text-gray-900 transition-colors"
                title="Voir">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M11.9994 6.6884C13.808 6.68239 15.5815 7.18688 17.1162 8.14387C18.6509 9.10087 19.8843 10.4715 20.6748 12.0982C19.0518 15.413 15.7371 17.5081 11.9994 17.5081C8.26165 17.5081 4.9469 15.413 3.32395 12.0982C4.11439 10.4715 5.34785 9.10087 6.88252 8.14387C8.41719 7.18688 10.1908 6.68239 11.9994 6.6884ZM11.9994 4.72119C7.08133 4.72119 2.88133 7.78021 1.17969 12.0982C2.88133 16.4163 7.08133 19.4753 11.9994 19.4753C16.9174 19.4753 21.1174 16.4163 22.819 12.0982C21.1174 7.78021 16.9174 4.72119 11.9994 4.72119ZM11.9994 9.63922C12.6515 9.63922 13.277 9.8983 13.7381 10.3595C14.1993 10.8206 14.4584 11.4461 14.4584 12.0982C14.4584 12.7504 14.1993 13.3759 13.7381 13.837C13.277 14.2982 12.6515 14.5573 11.9994 14.5573C11.3472 14.5573 10.7217 14.2982 10.2606 13.837C9.79942 13.3759 9.54034 12.7504 9.54034 12.0982C9.54034 11.4461 9.79942 10.8206 10.2606 10.3595C10.7217 9.8983 11.3472 9.63922 11.9994 9.63922ZM11.9994 7.67201C9.56001 7.67201 7.57313 9.6589 7.57313 12.0982C7.57313 14.5376 9.56001 16.5245 11.9994 16.5245C14.4387 16.5245 16.4256 14.5376 16.4256 12.0982C16.4256 9.6589 14.4387 7.67201 11.9994 7.67201Z"
                    fill="#4B4848" />
                </svg>

              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
      <div class="text-sm text-gray-600">
        {{ t('reclamations.pagination.showing') }} 1 {{ t('reclamations.pagination.to') }} 5 {{
        t('reclamations.pagination.on') }} {{ totalResults }} {{ t('reclamations.pagination.results') }}
      </div>
      <div class="flex items-center gap-2">
        <button *ngFor="let page of [1, 2]" (click)="goToPage(page)"
          [class]="page === currentPage ? 'bg-[#FF5C01] text-white' : 'bg-white text-gray-700 hover:bg-gray-50'"
          class="w-10 h-10 rounded-lg flex items-center justify-center font-medium transition-colors border border-gray-300">
          {{ page }}
        </button>
        <button (click)="nextPage()"
          class="px-4 py-2 bg-white text-[#FF5C01] rounded-lg hover:bg-gray-50 transition-colors font-medium border border-gray-300">
          {{ t('reclamations.pagination.next') }}
        </button>
      </div>
    </div>
  </div>
</div>